"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HDSModelAppStreams = void 0;
/**
 * AppStreams - Extension of HDSModel
 *
 * Manages app-contextual stream definitions.
 * Each app/bridge access declares `clientData.appStreamId` (e.g. "bridge-mira-app").
 * AppStreams definitions declare sub-streams by suffix (e.g. suffix "notes" → "bridge-mira-app-notes").
 */
class HDSModelAppStreams {
    #model;
    #defs;
    constructor(model) {
        this.#model = model;
        this.#defs = null;
    }
    /** Get all app stream definitions */
    getAll() {
        if (!this.#defs) {
            this.#defs = [];
            const raw = this.#model.modelData.appStreams || {};
            for (const [key, def] of Object.entries(raw)) {
                const d = def;
                this.#defs.push({
                    key,
                    suffix: d.suffix,
                    eventType: d.eventType,
                    label: d.label || {},
                    description: d.description || {},
                    display: d.display || 'diary',
                });
            }
        }
        return this.#defs;
    }
    /** Get an app stream definition by key (e.g. "notes", "chat") */
    forKey(key) {
        return this.getAll().find(d => d.key === key) || null;
    }
    /**
     * Resolve the full stream ID for an app stream definition given an appStreamId.
     * E.g. resolveStreamId("bridge-mira-app", "notes") → "bridge-mira-app-notes"
     */
    resolveStreamId(appStreamId, key) {
        const def = this.forKey(key);
        if (!def)
            return null;
        return `${appStreamId}-${def.suffix}`;
    }
    /**
     * Resolve all app sub-stream IDs for a given appStreamId.
     * Returns a map of key → full stream ID.
     * E.g. resolveAll("bridge-mira-app") → { notes: "bridge-mira-app-notes", chat: "bridge-mira-app-chat" }
     */
    resolveAll(appStreamId) {
        const result = {};
        for (const def of this.getAll()) {
            result[def.key] = `${appStreamId}-${def.suffix}`;
        }
        return result;
    }
    /**
     * Check if a streamId belongs to an app stream.
     * Returns the app stream definition key if matched, null otherwise.
     * E.g. matchStream("bridge-mira-app-notes", "bridge-mira-app") → "notes"
     */
    matchStream(streamId, appStreamId) {
        for (const def of this.getAll()) {
            if (streamId === `${appStreamId}-${def.suffix}`)
                return def.key;
        }
        return null;
    }
    /**
     * Extract appStreamId from an access's clientData.
     * Returns null if not set.
     */
    static getAppStreamId(access) {
        return access?.clientData?.appStreamId || null;
    }
}
exports.HDSModelAppStreams = HDSModelAppStreams;
